
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Pivot, PivotItem } from 'office-ui-fabric-react/lib/Pivot';

import { DEFINITION_OPSUB } from '../../common/common/iskn/opsub';
import { DEFINITION_PAR } from '../../common/common/iskn/par';
import { DEFINITION_TEL } from '../../common/common/iskn/tel';

import IfComp from '../common/IfComp';
import IsknDataComboBox from '../common/IsknDataComboBox';

import IsknObjectInfo from './IsknObjectInfo';
import IsknObjectFilter from './IsknObjectFilter';
import IsknObjectList from './IsknObjectList';

const classNames = mergeStyleSets({
    IsknObjectExplorer: {
        //paddingLeft: 8
    },
    shadow: {
        boxShadow: 'rgb(0 0 0 / 18%) 0px 4.8px 14.4px 0px'
    },
    isknData: {
        width: 500
    }
});

const IsknObjectExplorer = ({
    isknDate,
    searchParamsValues,
    selectedObjectType,
    onChangeIsknDate,
    onChangeSelectedObjectType,
    onSearchClick
}) => {


    const handleTabClick = (pivotItem) => {
        if (onChangeSelectedObjectType) {
            onChangeSelectedObjectType(pivotItem.props.itemKey);
        }
    }

    return (
        <Stack verticalFill className={classNames.IsknObjectExplorer}>
            <Stack.Item className={classNames.isknData}>
                <IsknDataComboBox
                    isknDate={isknDate}
                    onChange={onChangeIsknDate}
                />
            </Stack.Item>
            <IfComp cond={isknDate}>
                <Stack.Item>
                    <Pivot
                        headersOnly={true}
                        selectedKey={selectedObjectType}
                        onLinkClick={handleTabClick}
                    >
                        <PivotItem headerText="PARCELY" itemKey={DEFINITION_PAR.objectType} />
                        <PivotItem headerText="LISTY VLASTNICTVÍ" itemKey={DEFINITION_TEL.objectType} />
                        <PivotItem headerText="VLASTNÍCI" itemKey={DEFINITION_OPSUB.objectType} />
                    </Pivot>

                </Stack.Item>
                <Stack.Item grow>
                    <IfComp cond={!!searchParamsValues}>
                        <Stack horizontal verticalFill tokens={{childrenGap: 16}} >
                            <Stack.Item className={classNames.shadow}>
                                <IsknObjectFilter objectType={selectedObjectType} />
                                <Stack horizontal horizontalAlign="start" className={classNames.buttons} tokens={{childrenGap: 8}}>
                                    <PrimaryButton
                                        text="Vyhledat"
                                        title="Vyhledat objekty podle zadaných parametrů"
                                        styles={{root: {width: 100}}}
                                        onClick={onSearchClick}
                                    />
                                </Stack>
                            </Stack.Item>
                            <Stack.Item grow>
                                <IsknObjectList
                                    isknDate={isknDate}
                                    objectType={selectedObjectType}
                                />
                            </Stack.Item>
                            <Stack.Item className={classNames.shadow}>
                                <IsknObjectInfo
                                    isknDate={isknDate}
                                />
                            </Stack.Item>
                        </Stack>
                    </IfComp>
                </Stack.Item>
            </IfComp>
        </Stack>
    );
}

export default IsknObjectExplorer;
